module.exports = __webpack_public_path__ + "isha-home.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/isha-home.jpg
// module id = 412
// module chunks = 0